var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-manage-booking-view d-flex flex-column"},[(_vm.bookingLoading)?_c('DataLoading',{staticClass:"mt-5 mb-5 pt-5 pb-5"}):_c('router-view',{key:_vm.bookingNeedsUpdate})],1)}
var staticRenderFns = []

export { render, staticRenderFns }